import useSWR from 'swr';
import { RentRollCard } from 'components/leases/expirations';
import { getOccupancyHistory } from 'waypoint-requests';
import React from 'react';
import OccupancyTrendCard from 'components/leases/expirations/cards/occupancy-trend/OccupancyTrendCard';
import TopTenantsCard from 'components/leases/tenants/top-tenants/TopTenantsCard';
import LeasesExpirationCard from 'components/leases/expirations/cards/leases-expiration/LeasesExpirationCard';
import UnitMixCard from 'components/leases/unit-mix/UnitMixCard';
import { usePermissions } from 'contexts';

export const LeasesSection = ({
    entityCode,
    hasOccupancyTrendEnabled,
    hasUnitMixEnabled,
}: {
    entityCode: string;
    hasOccupancyTrendEnabled: boolean;
    hasUnitMixEnabled: boolean;
}) => {
    const { featurePermissions } = usePermissions();
    const {
        data: occupancyHistory,
        error: occupancyHistoryError,
        isValidating: occupancyHistoryValidating,
    } = useSWR(`${entityCode}-property-detail-occupancy-trend`, () =>
        getOccupancyHistory([entityCode])
    );

    return (
        <div
            title={'Leases Section'}
            style={{ margin: '20px 0', padding: '0 24px' }}
            id="leases-section"
        >
            {hasOccupancyTrendEnabled && (
                <OccupancyTrendCard
                    entityCode={entityCode}
                    occupancyHistory={occupancyHistory ?? []}
                    isDataLoading={
                        occupancyHistoryValidating ||
                        (!occupancyHistoryError && !occupancyHistory)
                    }
                    dataLoadError={occupancyHistoryError}
                />
            )}

            <div style={{ marginTop: '20px' }}>
                <LeasesExpirationCard
                    boxShadow="none"
                    entityCodes={[entityCode]}
                />
            </div>
            <div id="leases-rent-roll" style={{ marginTop: '20px' }}>
                <RentRollCard entityCode={entityCode} hidePropertyColumns />
            </div>

            <div id="leases-top-tenants" style={{ marginTop: '20px' }}>
                <TopTenantsCard entityCode={entityCode} />
            </div>

            {hasUnitMixEnabled ? (
                <div id="leases-unit-mix" style={{ marginTop: '20px' }}>
                    <UnitMixCard entityCode={entityCode} hidePropertyColumns />
                </div>
            ) : null}
        </div>
    );
};
